<template>
  <transition name="fade">
    <signin v-if="isLoginOpen" @close="onCloseSignin" @signup="isLoginOpen = false;isSignupOpen = true"/>
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <transition name="fade">
    <join v-if="isSignupOpen" @close="onCloseSignup"/>
  </transition>

  <transition name="fade">
    <join-complete v-if="isSignupCompleteOpen" @close="isSignupCompleteOpen = false;isLoginOpen = true"/>
  </transition>

  <transition name="fade">
    <new-message v-if="isUnReadMessage" />
  </transition>
  <transition name="slide">
     <div class="leftHeader" :class="{ 'out': nside }" v-if="nside && commonCodeByOrder && gameCount">
        <ul>
          <li class="logowrap">
              <!-- <i @click="nside=!nside"><img src="@/assets/img/icon_menu.svg" /></i> -->
              <a @click="goPageByName('main')">
              <img src="@/assets/img/mega-logo.png" />
              </a>
          </li>
          <li>
            <div class="leftNav">
              <ul>
                <li @click="goPageByName('listcasino')" :class="{'on': $route.name === 'listcasino'}"><a><em class="lcasino"></em>라이브카지노</a></li>
                <li @click="goPageByName('listslot')" :class="{'on': $route.name === 'listslot'}"><a><em class="lslot"></em>슬롯</a></li>
              </ul>
            </div>
          </li>
        </ul>
     </div>
  </transition>
  <header v-if="gameCount" id="mainheader" :class="{ 'side': nside }">
    <ul class="header">
      <div class="topbannerin">
        <!-- <div class="speakerIcon"><img src="@/assets/img/icon_mega.svg"/></div> -->
        <span class="">{{ flowNotice }}</span>
      </div>
      <li class="menuWrap">
        <div class="naviwrap" >
          <template v-if="!userData">
            <div class="loginWrap">
              <ui-button :className="'loginbtn headerbtn'" :text="$t('front.gnb.login')" @click="onClickLogin"/>
              <ui-button :className="'joinbtn headerbtn'" :text="$t('front.common.signup')" @click="onClickSignup"/>
            </div>
          </template>
          <template v-else>
            <ul class="coninpoint compactTopInfo" v-if="userData">
              <li class="userItem">
                <span class="userName">{{ userData.memId }}</span>
                <span class="unit">님</span>
              </li>

              <li class="msgItem" @click="goPageByName('messageList')">
                <span class="msgLabel">쪽지</span>
                <em class="msgCount">({{ thousand(unReadMessageCount ? unReadMessageCount.toString() : '0') }})</em>
              </li>

              <li class="moneyItem">
                <span class="label">보유머니</span>
                <em class="value">{{ thousand(userData.cashAmt ? userData.cashAmt.toString() : '0') }}</em>
                <span class="unit">원</span>
              </li>

              <li class="pointItem">
                <span class="label">포인트</span>
                <em class="value">{{ thousand(userData.pointAmt ? userData.pointAmt.toString() : '0') }}</em>
                <span class="unit">원</span>
              </li>
            </ul>
            <!-- <ul class="coninpoint" v-if="userData">
              <li>
                <span class="text-basic"><em class="text-white">{{userData.memId}}</em>님</span>
              </li>
              <li @click="goPageByName('messageList')">
                <span class="msg">
                  <em class="text-basic">쪽지</em>
                  {{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}
               </span>
              </li>
              <li>
                <span>
                  보유머니 :
                  <em>{{thousand(userData.cashAmt ? userData.cashAmt.toString() : '0')}}</em> 원
                </span>
              </li>
              <li>
                <span>
                  포인트 :
                  <em>{{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}</em> P
                </span>
              </li>
              <li>
                <button class="refreshBtn">
                  <img src="../assets/img/icon/icon_refresh.svg">
                </button>
              </li>
              <li>
                <a @click="goPageByName('info')" class="myinfoBtn">회원정보</a>
              </li>
            </ul> -->
            <button class="hd-btn1" @click="goPageByName('point')">포인트전환</button>
            <button class="hd-btn1" @click="signOut">로그아웃</button>
          </template>
        </div>
      </li>
    </ul>
    <div class="topMenuBar" v-if="userData">
      <ul class="topMenuList">
        <li @click="goPageByName('bettingList')"><img src="../assets/gnb01.png">베팅내역</li>
        <li @click="goPageByName('notice')"><img src="../assets/gnb02.png">공지사항</li>
        <li @click="goPageByName('csCenter')"><img src="../assets/gnb04.png">고객센터</li>
        <li @click="goPageByName('charge')"><img src="../assets/gnb05.png">입금신청</li>
        <li @click="goPageByName('exchange')"><img src="../assets/gnb06.png">출금신청</li>
        <li v-if="userData && userData.isPartnerMember === 'Y'">
          <a :href="`https://${partnerDomain}/partnerMain`" target="_blank"><img src="../assets/gnb02.png">{{ $t('front.common.partner') }}</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>

import UiButton from '@/components/ui/UiButton'

import { mapState } from 'vuex'
import Join from '@/components/member/Join'
import JoinComplete from '@/components/member/JoinComplete'
import Signin from '@/components/member/Signin'
import TMmodal from '@/components/common/TotalMoney'
import { TRIPLE_GAME_LIST } from '@/libs/constants'
import NewMessage from '@/components/member/Message.vue'
import { getMainCashStatus, getFlowNotice } from '@/api/main'

export default {
  name: 'Header',
  components: {
    NewMessage,
    Signin,
    JoinComplete,
    Join,
    UiButton,
    TMmodal
  },
  data () {
    return {
      menuList: [],
      TMOpen: false,
      isLoginOpen: false,
      isSignupOpen: false,
      isSignupCompleteOpen: false,
      showMenu: false,
      showMenuMoney: false,
      showMenuLang: false,
      isAlertOpen: false,
      isGameOpen: false,
      isHgameOpen: false,
      isSlotOpen: false,
      isSportsOpen: false,
      isMiniOpen: false,
      isCashOpen: false,
      tripleGameList: TRIPLE_GAME_LIST,
      nside: true,
      flowNotice: ''
    }
  },
  watch: {
    $route: {
      handler (current) {
        this.gnbReset()
      }
    },
    async userData (newVal) {
      if (newVal) {
        this.getFlowNotice()
      }
    }
  },
  props: ['selectedMenu'],
  created () {
    this.setMenu()
    this.getHeadMsgList()
    this.loadCashStatus()
  },
  mounted () {
    if (this.userData) {
      this.getFlowNotice()
    }
  },
  computed: {
    ...mapState([
      'userData',
      'coinAmt',
      'commonCodeByOrder',
      'gameCount',
      'unReadMessageCount',
      'siteOption'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      const hostname = window.location.hostname
      if (hostname.includes('port-folio.cc')) return 'd29.port-folio.cc'
      return 'd29.port-folio.cc' // 기본값
    }
  },
  methods: {
    getFlowNotice () {
      getFlowNotice({}).then(res => {
        // console.log('flow', res)
        const result = res.data
        if (result.resultCode === '0') {
          this.flowNotice = result.data.content
        }
      })
    },
    loadCashStatus () {
      getMainCashStatus({}).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.cashInList = result.data.cashInList.slice(0, this.listMaxCount)
          this.cashOutList = result.data.cashOutList.slice(0, this.listMaxCount)
        }
      })
    },
    slotOpen (event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
    },
    gnbReset () {
      this.isGameOpen = false
      this.isHgameOpen = false
      this.isSlotOpen = false
      this.isSportsOpen = false
      this.isMiniOpen = false
      this.isCashOpen = false
      this.showMenu = false
      this.showMenuLang = false
    },
    gnbMenuOpen (type) {
      this.gnbReset()
      if (type === 'game') {
        this.isGameOpen = true
      } else if (type === 'hgame') {
        this.isHgameOpen = true
      } else if (type === 'slot') {
        this.isSlotOpen = true
      } else if (type === 'cash') {
        this.isCashOpen = true
      } else if (type === 'mypage') {
        this.showMenu = true
      } else if (type === 'lang') {
        this.showMenuLang = true
      } else if (type === 'sport') {
        this.isSportsOpen = true
      } else if (type === 'minigame') {
        this.isMiniOpen = true
      }
    },
    getHeadMsgList () {
      // getHeadMsg({}).then(response => {
      //   console.log(response)
      // })
    },
    setMenu () {
      const list = this.$router.getRoutes()
      for (let i = 0, iLen = list.length; i < iLen; i++) {
        const item = list[i]
        if (item.meta && item.meta.gnb) {
          item.isSubOpen = false
          this.menuList.push(item)
        }
      }
    },
    onClickGame (code, name) {
      this.gnbReset()
      if (code) {
        // minigame

        if (code === 'mg') {
          this.$router.push({ name: name })
        } else {
          this.onSelectGame(code)
        }
      } else {
        this.onCheck('준비 중입니다.')
      }
    },
    onClickGnb (item) {
      const name = item.name
      const meta = item.meta
      if (meta.game) {
        this.onSelectGame(meta.gameCode)
      } else {
        this.$router.push({ name: name })
      }
    },
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    onClickLogin () {
      this.isLoginOpen = true
      this.isSignupOpen = false
    },
    onClickSignup () {
      this.isLoginOpen = false
      this.isSignupOpen = true
    },
    onCloseSignin (value) {
      this.isLoginOpen = false
      if (value === 'join') {
        this.isSignupOpen = true
      }
      if (value === 'signin') {
        // location.reload()
      }
    },
    onCloseSignup (status) {
      this.isSignupOpen = false
      if (status) {
        this.isSignupCompleteOpen = true
      }
    }
  }
}
</script>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
